import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "17",
  viewBox: "0 0 16 17",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M9.00033 4.4999L11.1956 2.30464C11.4559 2.04429 11.878 2.04429 12.1384 2.30464L14.1956 4.36183C14.4559 4.62218 14.4559 5.04429 14.1956 5.30464L12.0003 7.4999M9.00033 4.4999L1.86225 11.638C1.73723 11.763 1.66699 11.9326 1.66699 12.1094V14.8332H4.39085C4.56766 14.8332 4.73723 14.763 4.86225 14.638L12.0003 7.4999M9.00033 4.4999L12.0003 7.4999",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render: render }